import { useState } from "react"
import { PencilSimple, Tag } from "@phosphor-icons/react"
import { CommandbarOverflow, CommandbarOverflowItem } from "~/components/design-system/components"
import MultiEditDialog from "~/components/planning/MultiEditDialog/MultiEditDialog"
import { EditSkuTagsDialog } from "~/components/planning/Tags/EditSkuTagsDialog"
import type { IVariantSummary } from "~/hooks/useVariantTableData"
import { getCommonVendors } from "~/utils/vendorUtils"

type Props = {
  selectedVariantIds: string[]
  variants: IVariantSummary[]
  onApplied: () => void
}

type OpenDialog = "edit" | "tags" | null

// Dialogs mount outside the menu, controlled: selecting a menu item unmounts a nested trigger.
export function NoosVariantOverflow({ selectedVariantIds, variants, onApplied }: Props) {
  const [openDialog, setOpenDialog] = useState<OpenDialog>(null)
  const close = () => setOpenDialog(null)

  return (
    <>
      <CommandbarOverflow ellipsis>
        <CommandbarOverflowItem
          icon={<PencilSimple />}
          requires="edit"
          onSelect={() => setOpenDialog("edit")}
        >
          {selectedVariantIds.length === 1 ? "Edit variant" : "Edit variants"}
        </CommandbarOverflowItem>
        <CommandbarOverflowItem
          icon={<Tag />}
          requires="edit"
          onSelect={() => setOpenDialog("tags")}
        >
          Tags
        </CommandbarOverflowItem>
      </CommandbarOverflow>
      <MultiEditDialog
        selectedSkuIds={variants.flatMap((v) => v.skuIds)}
        selectedVariantCount={selectedVariantIds.length}
        commonVendors={getCommonVendors(variants)}
        resetSelectedProductIds={onApplied}
        open={openDialog === "edit"}
        onOpenChange={(next) => !next && close()}
      />
      <EditSkuTagsDialog
        variantIds={selectedVariantIds}
        open={openDialog === "tags"}
        onOpenChange={(next) => !next && close()}
      />
    </>
  )
}
